module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("实名信息审核")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "model": _vm.userInfo,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userDetail.nickName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userDetail.username))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('div', [(_vm.userDetail.gender === '1') ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.userDetail.gender === '2') ? _c('span', [_vm._v("女")]) : _vm._e(), _vm._v(" "), (_vm.userDetail.gender === '0' || _vm.userDetail.gender === null) ? _c('span', [_vm._v("暂无")]) : _vm._e()])]), _vm._v(" "), (_vm.userInfo && _vm.userInfo.zmUpdated) ? _c('el-form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('span', [_vm._v(_vm._s(new Date(_vm.userInfo.zmUpdated).getFullYear() + '-' + (new Date(_vm.userInfo.zmUpdated).getMonth() + 1) + '-' + new Date(_vm.userInfo.zmUpdated).getDate() + ' ' + new Date(_vm.userInfo.zmUpdated).getHours() + ':' + new Date(_vm.userInfo.zmUpdated).getMinutes() + ':' + new Date(_vm.userInfo.zmUpdated).getSeconds()) + " ")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "真实姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.realName || '未填写'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.idCard))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "工作单位／学校"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.institution))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "现居住地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.address || '暂无'))])]), _vm._v(" "), (_vm.userInfo.pictures) ? _c('el-form-item', {
    attrs: {
      "label": "身份证照片"
    }
  }, [(_vm.userInfo.pictures[0].length < 4) ? _c('span', [_vm._v("暂未上传")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userInfo.pictures), function(item, index) {
    return (index != 3) ? _c('img', {
      key: index,
      staticStyle: {
        "margin-right": "15px",
        "width": "200px"
      },
      attrs: {
        "src": item,
        "alt": ""
      }
    }) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.userInfo.pictures && _vm.userInfo.pictures[3].length) ? _c('el-form-item', {
    attrs: {
      "label": "学生证照片"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "15px",
      "width": "300px"
    },
    attrs: {
      "src": _vm.userInfo.pictures[3],
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleNo
    }
  }, [_vm._v("审核不通过")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("审核通过，请输入免押金额度（单位：分）")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.line),
      callback: function($$v) {
        _vm.line = $$v
      },
      expression: "line"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureEnter
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.passVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.passVisible = $event
      }
    }
  }, [_c('span', [_vm._v("审核不通过，请输入原因")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.passVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePass
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d56e4b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/ChangeIdentified.vue
// module id = 735
// module chunks = 1